<template>
  <!-- 换货补发：供应商对换货单补发同等数量，生成挂售后单的发货单（不占原订单可发数量） -->
  <div class="redelivery-wrapper">
    <div class="header">
      <a-button icon="arrow-left" size="small" @click="() => $router.back()" />
      <span class="page_type">换货补发</span>
    </div>
    <div class="content">
      <div class="common">
        <div class="title gap-12">补发清单</div>
        <div class="sub-title">售后单 {{ detailInfo.outRefundCode || detailInfo.code }} · 换货 · 原订单 {{ detailInfo.orderCode }}</div>
        <div v-for="goods in goodsList" :key="goods.id" class="goods-block">
          <div class="goods-head">
            <span class="name">{{ goods.goodsName }}</span>
            <span>商品编码：{{ goods.outSkuCode || goods.skuCode || '--' }}</span>
            <span>规格型号：{{ [goods.specification, goods.model].filter(Boolean).join(' / ') || '--' }}</span>
            <span>是否医疗件：{{ goods.medicalFlag ? '是' : '否' }}</span>
            <span>售后数量：{{ goods.quantity }}</span>
            <span>已补发：{{ goods.redeliveredQuantity || 0 }}</span>
            <span>待补发：<b>{{ goods.waitQuantity }}</b></span>
            <span>本次补发：<b :class="{ 'warn': rowsTotal(goods) > goods.waitQuantity }">{{ rowsTotal(goods) }}</b></span>
          </div>
          <el-table :data="goods.rows" size="small" border>
            <el-table-column label="生产批次号" min-width="150">
              <template slot-scope="{ row }">
                <el-input v-model.trim="row.batchNo" size="mini" placeholder="请输入生产批次号" />
              </template>
            </el-table-column>
            <el-table-column label="生产序列号" min-width="150">
              <template slot-scope="{ row }">
                <el-input v-model.trim="row.serialNo" size="mini" placeholder="请输入生产序列号" @input="(v) => v && (row.quantity = 1)" />
              </template>
            </el-table-column>
            <el-table-column min-width="150">
              <template slot="header"><span style="color: red;">*</span>生产日期</template>
              <template slot-scope="{ row }">
                <el-date-picker v-model="row.productionDate" type="date" size="mini" value-format="yyyy-MM-dd" placeholder="请选择" style="width: 140px" />
              </template>
            </el-table-column>
            <el-table-column min-width="150">
              <template slot="header"><span style="color: red;">*</span>失效日期</template>
              <template slot-scope="{ row }">
                <el-date-picker v-model="row.expiryDate" type="date" size="mini" value-format="yyyy-MM-dd" placeholder="请选择" style="width: 140px" />
              </template>
            </el-table-column>
            <el-table-column label="数量" width="140">
              <template slot-scope="{ row }">
                <el-input-number v-model="row.quantity" :min="0" :precision="0" :disabled="!!row.serialNo" controls-position="right" size="mini" style="width: 110px" />
              </template>
            </el-table-column>
            <el-table-column label="操作" width="90">
              <template slot-scope="{ $index }">
                <a v-if="goods.rows.length > 1" @click="goods.rows.splice($index, 1)">删除</a>
              </template>
            </el-table-column>
          </el-table>
          <el-button type="text" icon="el-icon-plus" @click="addRow(goods)">添加明细（多个批号或逐件填写序列号）</el-button>
        </div>
      </div>
      <div class="common">
        <div class="title gap-12">物流信息</div>
        <el-form ref="logisticForm" :model="logisticForm" :rules="logisticRules" inline size="small">
          <el-form-item label="物流公司" prop="company">
            <el-select v-model="logisticForm.company" value-key="id" filterable remote :remote-method="queryLogistics" placeholder="请选择物流公司">
              <el-option v-for="item in logisticsOptions" :key="item.id" :label="item.name" :value="item" />
            </el-select>
          </el-form-item>
          <el-form-item label="物流单号" prop="code">
            <el-input v-model.trim="logisticForm.code" placeholder="请输入物流单号" />
          </el-form-item>
        </el-form>
      </div>
    </div>
    <bottom-panel>
      <el-button size="small" @click="() => $router.back()">取消</el-button>
      <el-button type="primary" size="small" :loading="submitting" @click="submit">提交</el-button>
    </bottom-panel>
  </div>
</template>
<script>
import * as Moment from 'dayjs';
import BottomPanel from '@/components/common/bottomPanel';
import { refundDetail, redelivery } from '@/api/service';
import { logisticsCompany } from '@/api/pickUpOrders';

export default {
  name: 'service_redelivery',
  components: {
    BottomPanel,
  },
  props: {
    id: {
      type: String,
    },
  },
  data () {
    return {
      detailInfo: {},
      goodsList: [],
      logisticsOptions: [],
      logisticForm: {
        company: '',
        code: '',
      },
      logisticRules: {
        company: [{ required: true, message: '请选择物流公司', trigger: 'change' }],
        code: [{ required: true, message: '请输入物流单号', trigger: 'blur' }],
      },
      submitting: false,
    };
  },
  created () {
    this.getDetail();
    this.queryLogistics('');
  },
  methods: {
    // 非医疗件默认带出生产、失效日期（与正常发货一致）
    newRow (goods, quantity) {
      return {
        batchNo: '',
        serialNo: '',
        productionDate: goods.medicalFlag ? '' : Moment().add(-30, 'day').format('YYYY-MM-DD'),
        expiryDate: goods.medicalFlag ? '' : Moment().add(2, 'year').format('YYYY-MM-DD'),
        quantity,
      };
    },
    getDetail () {
      refundDetail({ id: this.id, findGoodsFlag: true }).then(({ body }) => {
        this.detailInfo = body || {};
        this.goodsList = (this.detailInfo.goodsList || []).map(goods => {
          const waitQuantity = Number(goods.quantity) - Number(goods.redeliveredQuantity || 0);
          return {
            ...goods,
            waitQuantity,
            rows: waitQuantity > 0 ? [this.newRow(goods, waitQuantity)] : [],
          };
        }).filter(goods => goods.waitQuantity > 0);
      });
    },
    queryLogistics (name = '') {
      logisticsCompany({
        name,
        pageFlag: true,
        pageNum: 1,
        pageSize: 20,
      }).then(({ body }) => {
        this.logisticsOptions = body.list || [];
      });
    },
    rowsTotal (goods) {
      return goods.rows.reduce((sum, row) => sum + (Number(row.quantity) || 0), 0);
    },
    addRow (goods) {
      goods.rows.push(this.newRow(goods, 1));
    },
    // 校验规则同正常发货：医疗件批次号或序列号至少一项；生产、失效日期必填；填序列号的明细数量为1；不超过待补发
    validateGoods () {
      for (const goods of this.goodsList) {
        const total = this.rowsTotal(goods);
        if (total > goods.waitQuantity) {
          return `【${goods.goodsName}】超出待补发数量 ${goods.waitQuantity}`;
        }
        for (const row of goods.rows.filter(item => Number(item.quantity) > 0)) {
          if (goods.medicalFlag && !row.batchNo && !row.serialNo) {
            return `【${goods.goodsName}】是医疗器械，须填写批次号或序列号`;
          }
          if (!row.productionDate || !row.expiryDate) {
            return `【${goods.goodsName}】生产日期、失效日期必填`;
          }
          if (row.serialNo && Number(row.quantity) !== 1) {
            return `【${goods.goodsName}】填写了序列号的明细数量须为1`;
          }
        }
      }
      if (!this.goodsList.some(goods => this.rowsTotal(goods) > 0)) {
        return '请填写本次补发数量';
      }
      return '';
    },
    submit () {
      const error = this.validateGoods();
      if (error) {
        this.$message.warning(error);
        return;
      }
      this.$refs.logisticForm.validate(async (valid) => {
        if (!valid) {
          return;
        }
        this.submitting = true;
        try {
          await redelivery({
            refundId: this.id,
            logisticsCompanyCode: this.logisticForm.company.code,
            logisticsCompanyName: this.logisticForm.company.name,
            logisticsCode: this.logisticForm.code,
            goodsList: this.goodsList
              .filter(goods => this.rowsTotal(goods) > 0)
              .map(goods => ({
                refundGoodsId: goods.id,
                quantity: this.rowsTotal(goods),
                serialList: goods.rows.filter(row => Number(row.quantity) > 0).map(row => ({
                  batchNo: row.batchNo,
                  serialNo: row.serialNo,
                  productionDate: new Date(row.productionDate).getTime(),
                  expiryDate: new Date(row.expiryDate).getTime(),
                  quantity: Number(row.quantity),
                })),
              })),
          });
          this.$message.success('补发成功');
          this.$router.back();
        } finally {
          this.submitting = false;
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.redelivery-wrapper {
  height: 100%;
  display: flex;
  flex-direction: column;

  .header {
    height: 52px;
    background-color: #fff;
    display: flex;
    align-items: center;
    padding: 12px;

    .page_type {
      font-size: 16px;
      font-weight: bold;
      margin-left: 1em;
    }
  }

  .content {
    flex: 1;
    padding: 8px 0 0;
    overflow: auto;

    .common {
      background-color: #fff;
      padding: 12px;
      margin-bottom: 6px;

      .title {
        font-weight: bold;
      }

      .gap-12 {
        margin-bottom: 12px;
      }

      .sub-title {
        font-size: 12px;
        color: #606266;
        margin-bottom: 8px;
      }

      .goods-block {
        margin-bottom: 16px;

        .goods-head {
          display: flex;
          flex-wrap: wrap;
          gap: 16px;
          font-size: 13px;
          color: #606266;
          margin-bottom: 6px;

          .name {
            font-weight: bold;
            color: #303133;
          }

          .warn {
            color: #F56C6C;
          }
        }
      }
    }
  }
}
</style>
